document.addEventListener("DOMContentLoaded", () => {
    var upsellQtyInputs = document.querySelectorAll("upsell-qty-input");
    upsellQtyInputs.forEach(function (upsellQtyInput) {
      var quantityInput = upsellQtyInput.querySelector(".quantity__input");
      var minusButton = upsellQtyInput.querySelector('button[name="minus"]');
      var plusButton = upsellQtyInput.querySelector('button[name="plus"]');
      var isInventoryTracked =
        upsellQtyInput.getAttribute("data-inventory-tracked") == "shopify";
      var variantId = upsellQtyInput.getAttribute("data-variantid");
  
      var cartData = window.cartInfo.items;
      var totalCartQuantity = cartData
        .filter((item) => item.variant_id == variantId)
        .reduce((total, item) => total + item.quantity, 0);
  
      if (!isInventoryTracked) {
        return;
      }
  
      var availableQuantity = parseInt(
        quantityInput.getAttribute("data-available-quantity"),
        10
      );
  
      function updateButtonsState() {
        if (totalCartQuantity) {
          var inputQuantity = parseInt(quantityInput.value, 10);
          var totalAvailable = availableQuantity - totalCartQuantity;
          if (totalAvailable == 0) {
            minusButton.setAttribute("disabled", "disabled");
          }
          if (inputQuantity > totalAvailable) {
            quantityInput.value = totalAvailable;
          }
  
          if (inputQuantity >= totalAvailable) {
            quantityInput.setAttribute("disabled", "disabled");
            plusButton.setAttribute("disabled", "disabled");
          } else {
            quantityInput.removeAttribute("disabled");
            plusButton.removeAttribute("disabled");
          }
        } else {
          var inputQuantity = parseInt(quantityInput.value, 10);
  
          if (inputQuantity > availableQuantity) {
            quantityInput.value = availableQuantity;
          }
  
          if (inputQuantity >= availableQuantity) {
            quantityInput.setAttribute("disabled", "disabled");
            plusButton.setAttribute("disabled", "disabled");
          } else {
            quantityInput.removeAttribute("disabled");
            plusButton.removeAttribute("disabled");
          }
        }
      }
  
      updateButtonsState();
      quantityInput.addEventListener("input", updateButtonsState);
      minusButton.addEventListener("click", function () {
        setTimeout(updateButtonsState, 100);
      });
  
      plusButton.addEventListener("click", function () {
        setTimeout(updateButtonsState, 100);
      });
    });
  });
  